type IdleCallback = () => void

type IdleWindow = Window & {
  requestIdleCallback?: (
    callback: IdleCallback,
    options?: { timeout: number },
  ) => number
}

export function scheduleNonCritical(callback: IdleCallback) {
  const schedule = () => {
    const idleWindow = window as IdleWindow

    if (idleWindow.requestIdleCallback) {
      idleWindow.requestIdleCallback(callback, { timeout: 200 })
      return
    }

    window.setTimeout(callback, 200)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true })
    return
  }

  schedule()
}
